import { isArray as R } from "./code-utils.js";
export default class Oe {
  constructor() {}
  ff() {}
  cf() {}
  rc(t) {}
  static lf(t, e) {
    if (t && e)
      if (((t = t.toLowerCase()), R(e.uf))) {
        for (let r = 0; r < e.uf.length; r++)
          if (-1 !== t.indexOf(e.uf[r].toLowerCase())) return e.identity;
      } else if (-1 !== t.indexOf(e.uf.toLowerCase())) return e.identity;
  }
}
